import React from 'react';
import { Grid, Box } from '@chakra-ui/react';

var BlankCard = function BlankCard() {
  return /*#__PURE__*/React.createElement(Box, {
    width: "32px",
    height: "24px",
    borderRadius: "4px",
    backgroundColor: "gray.200"
  });
};

export var getIconCard = function getIconCard(type) {
  var list = {
    visa: VisaIcon,
    mastercard: MasterCardIcon,
    jcb: JcbIcon,
    'american-express': AmexIcon,
    amex: AmexIcon
  };

  if (list[type]) {
    return list[type];
  }

  return BlankCard;
};
export var IconCreditCards = function IconCreditCards() {
  return /*#__PURE__*/React.createElement(Grid, {
    pl: "4",
    pr: "4",
    gap: "2",
    gridTemplateColumns: "repeat(auto-fill, minmax(34px, max-content))"
  }, /*#__PURE__*/React.createElement(VisaIcon, null), /*#__PURE__*/React.createElement(MasterCardIcon, null), /*#__PURE__*/React.createElement(AmexIcon, null));
};
export var VisaIcon = function VisaIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "26",
    viewBox: "0 0 34 26"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#E8E8E8",
    d: "M1.78 24C.8 24 0 23.156 0 22.125V1.875C0 .844.8 0 1.78 0h28.44C31.2 0 32 .844 32 1.875v20.25C32 23.156 31.2 24 30.22 24H1.78z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1F71",
    d: "M12.693 15.707L13.916 8.143 15.872 8.143 14.648 15.707zM21.738 8.328c-.387-.152-.998-.321-1.755-.321-1.93 0-3.29 1.03-3.299 2.502-.016 1.086.974 1.69 1.714 2.052.757.37 1.014.611 1.014.941-.008.507-.612.74-1.175.74-.78 0-1.199-.12-1.835-.402l-.257-.12-.273 1.697c.458.209 1.303.394 2.18.402 2.052 0 3.388-1.013 3.404-2.583.008-.86-.515-1.52-1.642-2.06-.684-.345-1.102-.579-1.102-.933.008-.321.354-.651 1.126-.651.636-.016 1.103.136 1.457.29l.177.08.266-1.634zM26.75 8.143h-1.512c-.467 0-.821.137-1.022.628l-2.905 6.936h2.052l.41-1.135h2.51c.057.266.234 1.135.234 1.135h1.81l-1.576-7.564zm-2.413 4.884l.78-2.116c-.008.016.161-.442.258-.724l.136.652s.37 1.81.451 2.188h-1.625zM11.06 8.143l-1.916 5.158-.209-1.046c-.354-1.207-1.464-2.518-2.704-3.17l1.755 6.614h2.068l3.074-7.556H11.06z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1F71",
    d: "M7.366 8.143H4.22l-.033.153c2.455.628 4.08 2.14 4.748 3.959l-.684-3.476c-.112-.483-.459-.62-.885-.636",
    transform: "translate(1 1)"
  })));
};
export var MasterCardIcon = function MasterCardIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "26",
    viewBox: "0 0 34 26"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#E8E8E8",
    d: "M1.78 24C.8 24 0 23.156 0 22.125V1.875C0 .844.8 0 1.78 0h28.44C31.2 0 32 .844 32 1.875v20.25C32 23.156 31.2 24 30.22 24H1.78z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E71B26",
    d: "M13.054 12.492c0-2.064.964-3.901 2.465-5.09C14.412 6.525 13.014 6 11.492 6 7.907 6 5 8.907 5 12.492c0 3.586 2.907 6.492 6.492 6.492 1.522 0 2.92-.525 4.027-1.401-1.501-1.19-2.465-3.027-2.465-5.09",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F36523",
    d: "M13.054 12.492c0 2.064.964 3.901 2.465 5.09 1.501-1.189 2.465-3.026 2.465-5.09s-.964-3.901-2.465-5.09c-1.501 1.189-2.465 3.026-2.465 5.09",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA9F1B",
    d: "M19.546 6c-1.522 0-2.92.525-4.027 1.402 1.501 1.189 2.465 3.026 2.465 5.09s-.964 3.901-2.465 5.09c1.107.877 2.505 1.402 4.027 1.402 3.586 0 6.492-2.906 6.492-6.492C26.038 8.907 23.132 6 19.546 6",
    transform: "translate(1 1)"
  })));
};
export var JcbIcon = function JcbIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "26",
    viewBox: "0 0 34 26"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#E8E8E8",
    d: "M1.78 24C.8 24 0 23.156 0 22.125V1.875C0 .844.8 0 1.78 0h28.44C31.2 0 32 .844 32 1.875v20.25C32 23.156 31.2 24 30.22 24H1.78z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F549D",
    fillRule: "nonzero",
    d: "M6.968 18.891h3.34c1.176 0 2.534-1.101 2.534-2.533V5.048h-3.23c-1.506 0-2.644.955-2.644 2.607v11.236z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B41F36",
    fillRule: "nonzero",
    d: "M13.576 18.891h3.341c1.175 0 2.533-1.101 2.533-2.533V5.048h-3.23c-1.506 0-2.644.955-2.644 2.607v11.236z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#329947",
    fillRule: "nonzero",
    d: "M20.275 18.891h3.341c1.175 0 2.534-1.101 2.534-2.533V5.048h-3.231c-1.505 0-2.643.955-2.643 2.607v11.236z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F3F2F2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.955 2.57H.037C.294 3.6 1.505 4.408 2.864 4.408c1.248 0 2.937-.698 2.937-2.02V.001H3.708v2.386c0 .698-.55 1.249-1.322 1.249-.697 0-1.321-.44-1.431-1.065zM19.272 3.048c0 .55-.477.991-1.102.991h-4.625V.001h4.625c.55 0 1.029.477 1.029 1.028 0 .55-.478 1.028-1.029 1.028.625 0 1.102.44 1.102.991zm-3.965-1.211h1.432c.367 0 .697-.33.697-.698 0-.367-.33-.698-.697-.698h-1.432v1.396zm1.469 1.762c.366 0 .697-.33.697-.698 0-.367-.33-.697-.697-.697h-1.47v1.394h1.47zM12.438 3.342v.697H8.914c-1.101 0-2.02-.917-2.02-2.019 0-1.1.919-2.019 2.02-2.019h3.524v.735c-.844-.184-1.652-.294-2.056-.294-.88 0-1.578.697-1.578 1.578 0 .882.697 1.579 1.578 1.579.404 0 1.212-.074 2.056-.257z",
    transform: "translate(1 1) translate(6 9.8)"
  }))));
};
export var AmexIcon = function AmexIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "24",
    viewBox: "0 0 32 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#016FD0",
    d: "M1.78 24C.8 24 0 23.156 0 22.125V1.875C0 .844.8 0 1.78 0h28.44C31.2 0 32 .844 32 1.875v20.25C32 23.156 31.2 24 30.22 24H1.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.416 8.56c0-.398-.391-.433-.554-.433h-.975v.808h.842c.182 0 .687.023.687-.375M23.808 8.199L23.288 9.523 24.344 9.523zM1.783 9.475L2.833 9.475 2.325 8.185zM26.934 18.236h-1.893v-.9h1.892c.177 0 .45-.07.45-.334s-.248-.301-.41-.301c-.259.003-.45 0-.952 0-.501 0-1.113-.266-1.113-1.21 0-.568.452-1.164 1.432-1.164h1.955l-.404.897h-1.667c-.085 0-.341.08-.341.311 0 .232.209.311.288.311l1.178.014c.565 0 1.038.455 1.038 1.09 0 .84-.51 1.286-1.453 1.286zm-2.309 0h-3.189v-3.91h3.178v.898h-2.17v.622h2.112v.832h-2.124v.66l2.193.004v.894zm-4.541 0l-1.166-1.428h-.352v1.428h-.998v-3.91h2.181c.716 0 1.313.474 1.313 1.31 0 .647-.412.962-.984 1.17l1.23 1.43h-1.224zm-4.16-1.311h-1.276v1.311h-.98v-3.91h2.1c.542 0 1.379.258 1.379 1.288 0 .949-.704 1.31-1.223 1.31zm-2.36 1.311h-1.247l-.883-1.294-.926 1.294H9.311l1.552-1.961-1.552-1.948h1.223l.9 1.22.944-1.22h1.203l-1.593 1.961 1.576 1.948zM9.23 15.21H7.055v.636h2.112v.798H7.055v.695H9.23v.897H6.062v-3.91H9.23v.884zm21.253 3.026h-1.894v-.9h1.893c.177 0 .45-.07.45-.334s-.248-.301-.411-.301c-.258.003-.449 0-.95 0-.503 0-1.114-.266-1.114-1.21 0-.568.452-1.164 1.431-1.164h1.961v-.778H11.997l-.554.735-.55-.735H5.218v5.455h5.68l.519-.747.502.747 3.48.003v-1.283h.299c.404.006.728.01 1.077-.16v1.44h2.328v-.883l.698.883H30.58c.96 0 1.27-.439 1.27-.439v-1.084c-.182.496-.65.755-1.367.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.686 11.161l-.98-2.803v2.803H4.7V7.308l1.552.01.91 2.46.854-2.526h1.534v3.91h-.958l-.023-2.85-1.027 2.85h-.855zm-3.15 0l-.358-.807H1.44l-.362.807H.01l1.668-3.865h1.27l1.68 3.865H3.538zm6.671-3.909h3.121v.887h-2.187v.632h2.135v.801H11.14v.725h2.187v.864h-3.12V7.252zm5.493 0c1.605 0 1.685.854 1.685 1.29 0 .624-.427 1.12-1.027 1.206l1.287 1.413H16.45l-1.207-1.378h-.351v1.378H13.9l-.011-3.909H15.7zm2.1 3.91h.953v-3.91h-.954v3.91zm3.376-3.91h1.048V8.2h-1.03c-.34 0-.987.156-.987 1.008 0 .94.662 1.12.908 1.12h.394l-.401.834h-.001c-1.065 0-1.854-.608-1.854-1.924 0-1.064.564-1.985 1.923-1.985zm3.272 0l1.67 3.91h-1.077l-.363-.816H22.93l-.353.815h-1.042l1.674-3.909h1.238zm3.003 0l1.541 2.436-.009-2.436h1.004v3.91h-1.194l-1.601-2.487v2.486h-.996l-.008-3.909h1.263zM15.435 11.93l.006-.853.68.853h3.41v-.467c.312.34.833.467 1.5.467h2.119l.363-.804h.623l.355.804h3.324v-.96l.632.96h2.363V6.477h-2.424v1.021l-.658-1.02h-2.233v1.375l-.602-1.376h-3.596c-1.096 0-1.488.34-1.777.536v-.536H7.564l-.427 1.027-.398-1.027H4.02V7.92l-.614-1.442H1.194L0 9.19v2.74h1.596l.36-.824.689.038.358.824 5.17-.035 7.262-.003zM19.68 15.196h-1.137v.817h1.16c.22 0 .393-.2.393-.408 0-.225-.15-.41-.416-.41M15.722 15.196h-1.085v.935h1.085c.193 0 .47-.133.47-.471 0-.342-.28-.464-.47-.464M29.772 15.224c-.085 0-.34.08-.34.311 0 .232.209.311.288.311l1.177.014c.421 0 .79.252.952.643V14.41l-.41.815h-1.667z"
  })));
};